<mat-icon #tooltip="matTooltip" class="action" (click)="openDialog()"
    matTooltip="Thông báo" 
    matTooltipPosition="below"
    [matBadge]="unreadNoti"
    matBadgeColor="warn">notifications</mat-icon>
